/**
 * @fileoverview gRPC-Web generated client stub for components
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js')
const proto = {};
proto.components = require('./components_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.UsersClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.UsersPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListUserRequest,
 *   !proto.components.ListUserResponse>}
 */
const methodDescriptor_Users_List = new grpc.web.MethodDescriptor(
  '/components.Users/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListUserRequest,
  proto.components.ListUserResponse,
  /**
   * @param {!proto.components.ListUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListUserResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/List',
      request,
      metadata || {},
      methodDescriptor_Users_List,
      callback);
};


/**
 * @param {!proto.components.ListUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListUserResponse>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/List',
      request,
      metadata || {},
      methodDescriptor_Users_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetUserRequest,
 *   !proto.components.GetUserResponse>}
 */
const methodDescriptor_Users_Get = new grpc.web.MethodDescriptor(
  '/components.Users/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetUserRequest,
  proto.components.GetUserResponse,
  /**
   * @param {!proto.components.GetUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetUserResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/Get',
      request,
      metadata || {},
      methodDescriptor_Users_Get,
      callback);
};


/**
 * @param {!proto.components.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetUserResponse>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/Get',
      request,
      metadata || {},
      methodDescriptor_Users_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateUserResponse>}
 */
const methodDescriptor_Users_Update = new grpc.web.MethodDescriptor(
  '/components.Users/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateUserResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateUserResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/Update',
      request,
      metadata || {},
      methodDescriptor_Users_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateUserResponse>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/Update',
      request,
      metadata || {},
      methodDescriptor_Users_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteUserRequest,
 *   !proto.components.DeleteUserResponse>}
 */
const methodDescriptor_Users_Delete = new grpc.web.MethodDescriptor(
  '/components.Users/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteUserRequest,
  proto.components.DeleteUserResponse,
  /**
   * @param {!proto.components.DeleteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteUserResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/Delete',
      request,
      metadata || {},
      methodDescriptor_Users_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteUserResponse>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/Delete',
      request,
      metadata || {},
      methodDescriptor_Users_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateUserRequest,
 *   !proto.components.CreateUserResponse>}
 */
const methodDescriptor_Users_Create = new grpc.web.MethodDescriptor(
  '/components.Users/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateUserRequest,
  proto.components.CreateUserResponse,
  /**
   * @param {!proto.components.CreateUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateUserResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/Create',
      request,
      metadata || {},
      methodDescriptor_Users_Create,
      callback);
};


/**
 * @param {!proto.components.CreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateUserResponse>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/Create',
      request,
      metadata || {},
      methodDescriptor_Users_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.RemoveIntegrationRequest,
 *   !proto.components.RemoveIntegrationResponse>}
 */
const methodDescriptor_Users_RemoveIntegration = new grpc.web.MethodDescriptor(
  '/components.Users/RemoveIntegration',
  grpc.web.MethodType.UNARY,
  proto.components.RemoveIntegrationRequest,
  proto.components.RemoveIntegrationResponse,
  /**
   * @param {!proto.components.RemoveIntegrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.RemoveIntegrationResponse.deserializeBinary
);


/**
 * @param {!proto.components.RemoveIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.RemoveIntegrationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.RemoveIntegrationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.removeIntegration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/RemoveIntegration',
      request,
      metadata || {},
      methodDescriptor_Users_RemoveIntegration,
      callback);
};


/**
 * @param {!proto.components.RemoveIntegrationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.RemoveIntegrationResponse>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.removeIntegration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/RemoveIntegration',
      request,
      metadata || {},
      methodDescriptor_Users_RemoveIntegration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateWebhooksArrayRequest,
 *   !proto.components.ObjectId>}
 */
const methodDescriptor_Users_UpdateWebhooksArray = new grpc.web.MethodDescriptor(
  '/components.Users/UpdateWebhooksArray',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateWebhooksArrayRequest,
  proto.components.ObjectId,
  /**
   * @param {!proto.components.UpdateWebhooksArrayRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ObjectId.deserializeBinary
);


/**
 * @param {!proto.components.UpdateWebhooksArrayRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ObjectId)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ObjectId>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.updateWebhooksArray =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/UpdateWebhooksArray',
      request,
      metadata || {},
      methodDescriptor_Users_UpdateWebhooksArray,
      callback);
};


/**
 * @param {!proto.components.UpdateWebhooksArrayRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ObjectId>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.updateWebhooksArray =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/UpdateWebhooksArray',
      request,
      metadata || {},
      methodDescriptor_Users_UpdateWebhooksArray);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteUserWithAuthRequest,
 *   !proto.components.DeleteUserWithAuthResponse>}
 */
const methodDescriptor_Users_DeleteUserWithAuth = new grpc.web.MethodDescriptor(
  '/components.Users/DeleteUserWithAuth',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteUserWithAuthRequest,
  proto.components.DeleteUserWithAuthResponse,
  /**
   * @param {!proto.components.DeleteUserWithAuthRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteUserWithAuthResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteUserWithAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteUserWithAuthResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteUserWithAuthResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.UsersClient.prototype.deleteUserWithAuth =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Users/DeleteUserWithAuth',
      request,
      metadata || {},
      methodDescriptor_Users_DeleteUserWithAuth,
      callback);
};


/**
 * @param {!proto.components.DeleteUserWithAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteUserWithAuthResponse>}
 *     Promise that resolves to the response
 */
proto.components.UsersPromiseClient.prototype.deleteUserWithAuth =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Users/DeleteUserWithAuth',
      request,
      metadata || {},
      methodDescriptor_Users_DeleteUserWithAuth);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.OrgsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.OrgsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListOrgRequest,
 *   !proto.components.ListOrgResponse>}
 */
const methodDescriptor_Orgs_List = new grpc.web.MethodDescriptor(
  '/components.Orgs/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListOrgRequest,
  proto.components.ListOrgResponse,
  /**
   * @param {!proto.components.ListOrgRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListOrgResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListOrgResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListOrgResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/List',
      request,
      metadata || {},
      methodDescriptor_Orgs_List,
      callback);
};


/**
 * @param {!proto.components.ListOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListOrgResponse>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/List',
      request,
      metadata || {},
      methodDescriptor_Orgs_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetOrgRequest,
 *   !proto.components.GetOrgResponse>}
 */
const methodDescriptor_Orgs_Get = new grpc.web.MethodDescriptor(
  '/components.Orgs/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetOrgRequest,
  proto.components.GetOrgResponse,
  /**
   * @param {!proto.components.GetOrgRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetOrgResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetOrgResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetOrgResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/Get',
      request,
      metadata || {},
      methodDescriptor_Orgs_Get,
      callback);
};


/**
 * @param {!proto.components.GetOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetOrgResponse>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/Get',
      request,
      metadata || {},
      methodDescriptor_Orgs_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateOrgResponse>}
 */
const methodDescriptor_Orgs_Update = new grpc.web.MethodDescriptor(
  '/components.Orgs/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateOrgResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateOrgResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateOrgResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateOrgResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/Update',
      request,
      metadata || {},
      methodDescriptor_Orgs_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateOrgResponse>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/Update',
      request,
      metadata || {},
      methodDescriptor_Orgs_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteOrgRequest,
 *   !proto.components.DeleteOrgResponse>}
 */
const methodDescriptor_Orgs_Delete = new grpc.web.MethodDescriptor(
  '/components.Orgs/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteOrgRequest,
  proto.components.DeleteOrgResponse,
  /**
   * @param {!proto.components.DeleteOrgRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteOrgResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteOrgResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteOrgResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/Delete',
      request,
      metadata || {},
      methodDescriptor_Orgs_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteOrgResponse>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/Delete',
      request,
      metadata || {},
      methodDescriptor_Orgs_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateOrgRequest,
 *   !proto.components.CreateOrgResponse>}
 */
const methodDescriptor_Orgs_Create = new grpc.web.MethodDescriptor(
  '/components.Orgs/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateOrgRequest,
  proto.components.CreateOrgResponse,
  /**
   * @param {!proto.components.CreateOrgRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateOrgResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateOrgResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateOrgResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/Create',
      request,
      metadata || {},
      methodDescriptor_Orgs_Create,
      callback);
};


/**
 * @param {!proto.components.CreateOrgRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateOrgResponse>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/Create',
      request,
      metadata || {},
      methodDescriptor_Orgs_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.RemoveSubscriptionRequest,
 *   !proto.components.RemoveSubscriptionResponse>}
 */
const methodDescriptor_Orgs_RemoveSubscription = new grpc.web.MethodDescriptor(
  '/components.Orgs/RemoveSubscription',
  grpc.web.MethodType.UNARY,
  proto.components.RemoveSubscriptionRequest,
  proto.components.RemoveSubscriptionResponse,
  /**
   * @param {!proto.components.RemoveSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.RemoveSubscriptionResponse.deserializeBinary
);


/**
 * @param {!proto.components.RemoveSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.RemoveSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.RemoveSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.removeSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/RemoveSubscription',
      request,
      metadata || {},
      methodDescriptor_Orgs_RemoveSubscription,
      callback);
};


/**
 * @param {!proto.components.RemoveSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.RemoveSubscriptionResponse>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.removeSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/RemoveSubscription',
      request,
      metadata || {},
      methodDescriptor_Orgs_RemoveSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateWebhooksArrayRequest,
 *   !proto.components.ObjectId>}
 */
const methodDescriptor_Orgs_UpdateWebhooksArray = new grpc.web.MethodDescriptor(
  '/components.Orgs/UpdateWebhooksArray',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateWebhooksArrayRequest,
  proto.components.ObjectId,
  /**
   * @param {!proto.components.UpdateWebhooksArrayRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ObjectId.deserializeBinary
);


/**
 * @param {!proto.components.UpdateWebhooksArrayRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ObjectId)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ObjectId>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.updateWebhooksArray =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/UpdateWebhooksArray',
      request,
      metadata || {},
      methodDescriptor_Orgs_UpdateWebhooksArray,
      callback);
};


/**
 * @param {!proto.components.UpdateWebhooksArrayRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ObjectId>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.updateWebhooksArray =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/UpdateWebhooksArray',
      request,
      metadata || {},
      methodDescriptor_Orgs_UpdateWebhooksArray);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteCompanyRequest,
 *   !proto.components.DeleteCompanyResponse>}
 */
const methodDescriptor_Orgs_DeleteCompany = new grpc.web.MethodDescriptor(
  '/components.Orgs/DeleteCompany',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteCompanyRequest,
  proto.components.DeleteCompanyResponse,
  /**
   * @param {!proto.components.DeleteCompanyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteCompanyResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteCompanyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteCompanyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteCompanyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OrgsClient.prototype.deleteCompany =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Orgs/DeleteCompany',
      request,
      metadata || {},
      methodDescriptor_Orgs_DeleteCompany,
      callback);
};


/**
 * @param {!proto.components.DeleteCompanyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteCompanyResponse>}
 *     Promise that resolves to the response
 */
proto.components.OrgsPromiseClient.prototype.deleteCompany =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Orgs/DeleteCompany',
      request,
      metadata || {},
      methodDescriptor_Orgs_DeleteCompany);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.WebhooksClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.WebhooksPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListWebhookRequest,
 *   !proto.components.ListWebhookResponse>}
 */
const methodDescriptor_Webhooks_List = new grpc.web.MethodDescriptor(
  '/components.Webhooks/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListWebhookRequest,
  proto.components.ListWebhookResponse,
  /**
   * @param {!proto.components.ListWebhookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListWebhookResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListWebhookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListWebhookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WebhooksClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Webhooks/List',
      request,
      metadata || {},
      methodDescriptor_Webhooks_List,
      callback);
};


/**
 * @param {!proto.components.ListWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListWebhookResponse>}
 *     Promise that resolves to the response
 */
proto.components.WebhooksPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Webhooks/List',
      request,
      metadata || {},
      methodDescriptor_Webhooks_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetWebhookRequest,
 *   !proto.components.GetWebhookResponse>}
 */
const methodDescriptor_Webhooks_Get = new grpc.web.MethodDescriptor(
  '/components.Webhooks/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetWebhookRequest,
  proto.components.GetWebhookResponse,
  /**
   * @param {!proto.components.GetWebhookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetWebhookResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetWebhookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetWebhookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WebhooksClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Webhooks/Get',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Get,
      callback);
};


/**
 * @param {!proto.components.GetWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetWebhookResponse>}
 *     Promise that resolves to the response
 */
proto.components.WebhooksPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Webhooks/Get',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateWebhookResponse>}
 */
const methodDescriptor_Webhooks_Update = new grpc.web.MethodDescriptor(
  '/components.Webhooks/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateWebhookResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateWebhookResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateWebhookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateWebhookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WebhooksClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Webhooks/Update',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateWebhookResponse>}
 *     Promise that resolves to the response
 */
proto.components.WebhooksPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Webhooks/Update',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteWebhookRequest,
 *   !proto.components.DeleteWebhookResponse>}
 */
const methodDescriptor_Webhooks_Delete = new grpc.web.MethodDescriptor(
  '/components.Webhooks/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteWebhookRequest,
  proto.components.DeleteWebhookResponse,
  /**
   * @param {!proto.components.DeleteWebhookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteWebhookResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteWebhookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteWebhookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WebhooksClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Webhooks/Delete',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteWebhookResponse>}
 *     Promise that resolves to the response
 */
proto.components.WebhooksPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Webhooks/Delete',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateWebhookRequest,
 *   !proto.components.CreateWebhookResponse>}
 */
const methodDescriptor_Webhooks_Create = new grpc.web.MethodDescriptor(
  '/components.Webhooks/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateWebhookRequest,
  proto.components.CreateWebhookResponse,
  /**
   * @param {!proto.components.CreateWebhookRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateWebhookResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateWebhookResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateWebhookResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WebhooksClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Webhooks/Create',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Create,
      callback);
};


/**
 * @param {!proto.components.CreateWebhookRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateWebhookResponse>}
 *     Promise that resolves to the response
 */
proto.components.WebhooksPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Webhooks/Create',
      request,
      metadata || {},
      methodDescriptor_Webhooks_Create);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.TriggersClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.TriggersPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListTriggerRequest,
 *   !proto.components.ListTriggerResponse>}
 */
const methodDescriptor_Triggers_List = new grpc.web.MethodDescriptor(
  '/components.Triggers/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListTriggerRequest,
  proto.components.ListTriggerResponse,
  /**
   * @param {!proto.components.ListTriggerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListTriggerResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListTriggerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListTriggerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TriggersClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Triggers/List',
      request,
      metadata || {},
      methodDescriptor_Triggers_List,
      callback);
};


/**
 * @param {!proto.components.ListTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListTriggerResponse>}
 *     Promise that resolves to the response
 */
proto.components.TriggersPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Triggers/List',
      request,
      metadata || {},
      methodDescriptor_Triggers_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetTriggerRequest,
 *   !proto.components.GetTriggerResponse>}
 */
const methodDescriptor_Triggers_Get = new grpc.web.MethodDescriptor(
  '/components.Triggers/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetTriggerRequest,
  proto.components.GetTriggerResponse,
  /**
   * @param {!proto.components.GetTriggerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetTriggerResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetTriggerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetTriggerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TriggersClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Triggers/Get',
      request,
      metadata || {},
      methodDescriptor_Triggers_Get,
      callback);
};


/**
 * @param {!proto.components.GetTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetTriggerResponse>}
 *     Promise that resolves to the response
 */
proto.components.TriggersPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Triggers/Get',
      request,
      metadata || {},
      methodDescriptor_Triggers_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateTriggerResponse>}
 */
const methodDescriptor_Triggers_Update = new grpc.web.MethodDescriptor(
  '/components.Triggers/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateTriggerResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateTriggerResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateTriggerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateTriggerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TriggersClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Triggers/Update',
      request,
      metadata || {},
      methodDescriptor_Triggers_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateTriggerResponse>}
 *     Promise that resolves to the response
 */
proto.components.TriggersPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Triggers/Update',
      request,
      metadata || {},
      methodDescriptor_Triggers_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteTriggerRequest,
 *   !proto.components.DeleteTriggerResponse>}
 */
const methodDescriptor_Triggers_Delete = new grpc.web.MethodDescriptor(
  '/components.Triggers/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteTriggerRequest,
  proto.components.DeleteTriggerResponse,
  /**
   * @param {!proto.components.DeleteTriggerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteTriggerResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteTriggerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteTriggerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TriggersClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Triggers/Delete',
      request,
      metadata || {},
      methodDescriptor_Triggers_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteTriggerResponse>}
 *     Promise that resolves to the response
 */
proto.components.TriggersPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Triggers/Delete',
      request,
      metadata || {},
      methodDescriptor_Triggers_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateTriggerRequest,
 *   !proto.components.CreateTriggerResponse>}
 */
const methodDescriptor_Triggers_Create = new grpc.web.MethodDescriptor(
  '/components.Triggers/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateTriggerRequest,
  proto.components.CreateTriggerResponse,
  /**
   * @param {!proto.components.CreateTriggerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateTriggerResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateTriggerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateTriggerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TriggersClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Triggers/Create',
      request,
      metadata || {},
      methodDescriptor_Triggers_Create,
      callback);
};


/**
 * @param {!proto.components.CreateTriggerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateTriggerResponse>}
 *     Promise that resolves to the response
 */
proto.components.TriggersPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Triggers/Create',
      request,
      metadata || {},
      methodDescriptor_Triggers_Create);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.AppsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.AppsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListAppRequest,
 *   !proto.components.ListAppResponse>}
 */
const methodDescriptor_Apps_List = new grpc.web.MethodDescriptor(
  '/components.Apps/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListAppRequest,
  proto.components.ListAppResponse,
  /**
   * @param {!proto.components.ListAppRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListAppResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListAppRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListAppResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListAppResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Apps/List',
      request,
      metadata || {},
      methodDescriptor_Apps_List,
      callback);
};


/**
 * @param {!proto.components.ListAppRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListAppResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Apps/List',
      request,
      metadata || {},
      methodDescriptor_Apps_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetAppRequest,
 *   !proto.components.GetAppResponse>}
 */
const methodDescriptor_Apps_Get = new grpc.web.MethodDescriptor(
  '/components.Apps/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetAppRequest,
  proto.components.GetAppResponse,
  /**
   * @param {!proto.components.GetAppRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetAppResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetAppRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetAppResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetAppResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Apps/Get',
      request,
      metadata || {},
      methodDescriptor_Apps_Get,
      callback);
};


/**
 * @param {!proto.components.GetAppRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetAppResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Apps/Get',
      request,
      metadata || {},
      methodDescriptor_Apps_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateAppResponse>}
 */
const methodDescriptor_Apps_Update = new grpc.web.MethodDescriptor(
  '/components.Apps/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateAppResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateAppResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateAppResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateAppResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Apps/Update',
      request,
      metadata || {},
      methodDescriptor_Apps_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateAppResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Apps/Update',
      request,
      metadata || {},
      methodDescriptor_Apps_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteAppRequest,
 *   !proto.components.DeleteAppResponse>}
 */
const methodDescriptor_Apps_Delete = new grpc.web.MethodDescriptor(
  '/components.Apps/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteAppRequest,
  proto.components.DeleteAppResponse,
  /**
   * @param {!proto.components.DeleteAppRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteAppResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteAppRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteAppResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteAppResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Apps/Delete',
      request,
      metadata || {},
      methodDescriptor_Apps_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteAppRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteAppResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Apps/Delete',
      request,
      metadata || {},
      methodDescriptor_Apps_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateAppRequest,
 *   !proto.components.CreateAppResponse>}
 */
const methodDescriptor_Apps_Create = new grpc.web.MethodDescriptor(
  '/components.Apps/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateAppRequest,
  proto.components.CreateAppResponse,
  /**
   * @param {!proto.components.CreateAppRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateAppResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateAppRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateAppResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateAppResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Apps/Create',
      request,
      metadata || {},
      methodDescriptor_Apps_Create,
      callback);
};


/**
 * @param {!proto.components.CreateAppRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateAppResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Apps/Create',
      request,
      metadata || {},
      methodDescriptor_Apps_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.LoadAppKeysRequest,
 *   !proto.components.LoadAppKeysResponse>}
 */
const methodDescriptor_Apps_LoadAppKeys = new grpc.web.MethodDescriptor(
  '/components.Apps/LoadAppKeys',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.components.LoadAppKeysRequest,
  proto.components.LoadAppKeysResponse,
  /**
   * @param {!proto.components.LoadAppKeysRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.LoadAppKeysResponse.deserializeBinary
);


/**
 * @param {!proto.components.LoadAppKeysRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.components.LoadAppKeysResponse>}
 *     The XHR Node Readable Stream
 */
proto.components.AppsClient.prototype.loadAppKeys =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/components.Apps/LoadAppKeys',
      request,
      metadata || {},
      methodDescriptor_Apps_LoadAppKeys);
};


/**
 * @param {!proto.components.LoadAppKeysRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.components.LoadAppKeysResponse>}
 *     The XHR Node Readable Stream
 */
proto.components.AppsPromiseClient.prototype.loadAppKeys =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/components.Apps/LoadAppKeys',
      request,
      metadata || {},
      methodDescriptor_Apps_LoadAppKeys);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateAppHashRequest,
 *   !proto.components.CreateAppHashResponse>}
 */
const methodDescriptor_Apps_GetAppHash = new grpc.web.MethodDescriptor(
  '/components.Apps/GetAppHash',
  grpc.web.MethodType.UNARY,
  proto.components.CreateAppHashRequest,
  proto.components.CreateAppHashResponse,
  /**
   * @param {!proto.components.CreateAppHashRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateAppHashResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateAppHashRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateAppHashResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateAppHashResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppsClient.prototype.getAppHash =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Apps/GetAppHash',
      request,
      metadata || {},
      methodDescriptor_Apps_GetAppHash,
      callback);
};


/**
 * @param {!proto.components.CreateAppHashRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateAppHashResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppsPromiseClient.prototype.getAppHash =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Apps/GetAppHash',
      request,
      metadata || {},
      methodDescriptor_Apps_GetAppHash);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.OperationsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.OperationsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListOperationRequest,
 *   !proto.components.ListOperationResponse>}
 */
const methodDescriptor_Operations_List = new grpc.web.MethodDescriptor(
  '/components.Operations/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListOperationRequest,
  proto.components.ListOperationResponse,
  /**
   * @param {!proto.components.ListOperationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListOperationResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OperationsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Operations/List',
      request,
      metadata || {},
      methodDescriptor_Operations_List,
      callback);
};


/**
 * @param {!proto.components.ListOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListOperationResponse>}
 *     Promise that resolves to the response
 */
proto.components.OperationsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Operations/List',
      request,
      metadata || {},
      methodDescriptor_Operations_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetOperationRequest,
 *   !proto.components.GetOperationResponse>}
 */
const methodDescriptor_Operations_Get = new grpc.web.MethodDescriptor(
  '/components.Operations/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetOperationRequest,
  proto.components.GetOperationResponse,
  /**
   * @param {!proto.components.GetOperationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetOperationResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OperationsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Operations/Get',
      request,
      metadata || {},
      methodDescriptor_Operations_Get,
      callback);
};


/**
 * @param {!proto.components.GetOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetOperationResponse>}
 *     Promise that resolves to the response
 */
proto.components.OperationsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Operations/Get',
      request,
      metadata || {},
      methodDescriptor_Operations_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateOperationResponse>}
 */
const methodDescriptor_Operations_Update = new grpc.web.MethodDescriptor(
  '/components.Operations/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateOperationResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateOperationResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OperationsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Operations/Update',
      request,
      metadata || {},
      methodDescriptor_Operations_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateOperationResponse>}
 *     Promise that resolves to the response
 */
proto.components.OperationsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Operations/Update',
      request,
      metadata || {},
      methodDescriptor_Operations_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteOperationRequest,
 *   !proto.components.DeleteOperationResponse>}
 */
const methodDescriptor_Operations_Delete = new grpc.web.MethodDescriptor(
  '/components.Operations/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteOperationRequest,
  proto.components.DeleteOperationResponse,
  /**
   * @param {!proto.components.DeleteOperationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteOperationResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OperationsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Operations/Delete',
      request,
      metadata || {},
      methodDescriptor_Operations_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteOperationResponse>}
 *     Promise that resolves to the response
 */
proto.components.OperationsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Operations/Delete',
      request,
      metadata || {},
      methodDescriptor_Operations_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateOperationRequest,
 *   !proto.components.CreateOperationResponse>}
 */
const methodDescriptor_Operations_Create = new grpc.web.MethodDescriptor(
  '/components.Operations/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateOperationRequest,
  proto.components.CreateOperationResponse,
  /**
   * @param {!proto.components.CreateOperationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateOperationResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateOperationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateOperationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OperationsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Operations/Create',
      request,
      metadata || {},
      methodDescriptor_Operations_Create,
      callback);
};


/**
 * @param {!proto.components.CreateOperationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateOperationResponse>}
 *     Promise that resolves to the response
 */
proto.components.OperationsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Operations/Create',
      request,
      metadata || {},
      methodDescriptor_Operations_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateOperationsRequest,
 *   !proto.components.CreateOperationsResponse>}
 */
const methodDescriptor_Operations_CreateRecords = new grpc.web.MethodDescriptor(
  '/components.Operations/CreateRecords',
  grpc.web.MethodType.UNARY,
  proto.components.CreateOperationsRequest,
  proto.components.CreateOperationsResponse,
  /**
   * @param {!proto.components.CreateOperationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateOperationsResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateOperationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateOperationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateOperationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.OperationsClient.prototype.createRecords =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Operations/CreateRecords',
      request,
      metadata || {},
      methodDescriptor_Operations_CreateRecords,
      callback);
};


/**
 * @param {!proto.components.CreateOperationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateOperationsResponse>}
 *     Promise that resolves to the response
 */
proto.components.OperationsPromiseClient.prototype.createRecords =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Operations/CreateRecords',
      request,
      metadata || {},
      methodDescriptor_Operations_CreateRecords);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.WorkflowsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.WorkflowsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListWorkflowRequest,
 *   !proto.components.ListWorkflowResponse>}
 */
const methodDescriptor_Workflows_List = new grpc.web.MethodDescriptor(
  '/components.Workflows/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListWorkflowRequest,
  proto.components.ListWorkflowResponse,
  /**
   * @param {!proto.components.ListWorkflowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListWorkflowResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListWorkflowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListWorkflowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WorkflowsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Workflows/List',
      request,
      metadata || {},
      methodDescriptor_Workflows_List,
      callback);
};


/**
 * @param {!proto.components.ListWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListWorkflowResponse>}
 *     Promise that resolves to the response
 */
proto.components.WorkflowsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Workflows/List',
      request,
      metadata || {},
      methodDescriptor_Workflows_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetWorkflowRequest,
 *   !proto.components.GetWorkflowResponse>}
 */
const methodDescriptor_Workflows_Get = new grpc.web.MethodDescriptor(
  '/components.Workflows/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetWorkflowRequest,
  proto.components.GetWorkflowResponse,
  /**
   * @param {!proto.components.GetWorkflowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetWorkflowResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetWorkflowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetWorkflowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WorkflowsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Workflows/Get',
      request,
      metadata || {},
      methodDescriptor_Workflows_Get,
      callback);
};


/**
 * @param {!proto.components.GetWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetWorkflowResponse>}
 *     Promise that resolves to the response
 */
proto.components.WorkflowsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Workflows/Get',
      request,
      metadata || {},
      methodDescriptor_Workflows_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateWorkflowResponse>}
 */
const methodDescriptor_Workflows_Update = new grpc.web.MethodDescriptor(
  '/components.Workflows/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateWorkflowResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateWorkflowResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateWorkflowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateWorkflowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WorkflowsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Workflows/Update',
      request,
      metadata || {},
      methodDescriptor_Workflows_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateWorkflowResponse>}
 *     Promise that resolves to the response
 */
proto.components.WorkflowsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Workflows/Update',
      request,
      metadata || {},
      methodDescriptor_Workflows_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteWorkflowRequest,
 *   !proto.components.DeleteWorkflowResponse>}
 */
const methodDescriptor_Workflows_Delete = new grpc.web.MethodDescriptor(
  '/components.Workflows/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteWorkflowRequest,
  proto.components.DeleteWorkflowResponse,
  /**
   * @param {!proto.components.DeleteWorkflowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteWorkflowResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteWorkflowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteWorkflowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WorkflowsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Workflows/Delete',
      request,
      metadata || {},
      methodDescriptor_Workflows_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteWorkflowResponse>}
 *     Promise that resolves to the response
 */
proto.components.WorkflowsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Workflows/Delete',
      request,
      metadata || {},
      methodDescriptor_Workflows_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateWorkflowRequest,
 *   !proto.components.CreateWorkflowResponse>}
 */
const methodDescriptor_Workflows_Create = new grpc.web.MethodDescriptor(
  '/components.Workflows/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateWorkflowRequest,
  proto.components.CreateWorkflowResponse,
  /**
   * @param {!proto.components.CreateWorkflowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateWorkflowResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateWorkflowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateWorkflowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WorkflowsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Workflows/Create',
      request,
      metadata || {},
      methodDescriptor_Workflows_Create,
      callback);
};


/**
 * @param {!proto.components.CreateWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateWorkflowResponse>}
 *     Promise that resolves to the response
 */
proto.components.WorkflowsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Workflows/Create',
      request,
      metadata || {},
      methodDescriptor_Workflows_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ActivateWorkflowRequest,
 *   !proto.components.ActivateWorkflowResponse>}
 */
const methodDescriptor_Workflows_ActivateWorkflow = new grpc.web.MethodDescriptor(
  '/components.Workflows/ActivateWorkflow',
  grpc.web.MethodType.UNARY,
  proto.components.ActivateWorkflowRequest,
  proto.components.ActivateWorkflowResponse,
  /**
   * @param {!proto.components.ActivateWorkflowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ActivateWorkflowResponse.deserializeBinary
);


/**
 * @param {!proto.components.ActivateWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ActivateWorkflowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ActivateWorkflowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.WorkflowsClient.prototype.activateWorkflow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Workflows/ActivateWorkflow',
      request,
      metadata || {},
      methodDescriptor_Workflows_ActivateWorkflow,
      callback);
};


/**
 * @param {!proto.components.ActivateWorkflowRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ActivateWorkflowResponse>}
 *     Promise that resolves to the response
 */
proto.components.WorkflowsPromiseClient.prototype.activateWorkflow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Workflows/ActivateWorkflow',
      request,
      metadata || {},
      methodDescriptor_Workflows_ActivateWorkflow);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.AppActionsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.AppActionsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListAppActionRequest,
 *   !proto.components.ListAppActionResponse>}
 */
const methodDescriptor_AppActions_List = new grpc.web.MethodDescriptor(
  '/components.AppActions/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListAppActionRequest,
  proto.components.ListAppActionResponse,
  /**
   * @param {!proto.components.ListAppActionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListAppActionResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListAppActionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListAppActionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppActionsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.AppActions/List',
      request,
      metadata || {},
      methodDescriptor_AppActions_List,
      callback);
};


/**
 * @param {!proto.components.ListAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListAppActionResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppActionsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.AppActions/List',
      request,
      metadata || {},
      methodDescriptor_AppActions_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetAppActionRequest,
 *   !proto.components.GetAppActionResponse>}
 */
const methodDescriptor_AppActions_Get = new grpc.web.MethodDescriptor(
  '/components.AppActions/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetAppActionRequest,
  proto.components.GetAppActionResponse,
  /**
   * @param {!proto.components.GetAppActionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetAppActionResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetAppActionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetAppActionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppActionsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.AppActions/Get',
      request,
      metadata || {},
      methodDescriptor_AppActions_Get,
      callback);
};


/**
 * @param {!proto.components.GetAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetAppActionResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppActionsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.AppActions/Get',
      request,
      metadata || {},
      methodDescriptor_AppActions_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateAppActionResponse>}
 */
const methodDescriptor_AppActions_Update = new grpc.web.MethodDescriptor(
  '/components.AppActions/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateAppActionResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateAppActionResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateAppActionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateAppActionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppActionsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.AppActions/Update',
      request,
      metadata || {},
      methodDescriptor_AppActions_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateAppActionResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppActionsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.AppActions/Update',
      request,
      metadata || {},
      methodDescriptor_AppActions_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteAppActionRequest,
 *   !proto.components.DeleteAppActionResponse>}
 */
const methodDescriptor_AppActions_Delete = new grpc.web.MethodDescriptor(
  '/components.AppActions/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteAppActionRequest,
  proto.components.DeleteAppActionResponse,
  /**
   * @param {!proto.components.DeleteAppActionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteAppActionResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteAppActionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteAppActionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppActionsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.AppActions/Delete',
      request,
      metadata || {},
      methodDescriptor_AppActions_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteAppActionResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppActionsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.AppActions/Delete',
      request,
      metadata || {},
      methodDescriptor_AppActions_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateAppActionRequest,
 *   !proto.components.CreateAppActionResponse>}
 */
const methodDescriptor_AppActions_Create = new grpc.web.MethodDescriptor(
  '/components.AppActions/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateAppActionRequest,
  proto.components.CreateAppActionResponse,
  /**
   * @param {!proto.components.CreateAppActionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateAppActionResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateAppActionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateAppActionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.AppActionsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.AppActions/Create',
      request,
      metadata || {},
      methodDescriptor_AppActions_Create,
      callback);
};


/**
 * @param {!proto.components.CreateAppActionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateAppActionResponse>}
 *     Promise that resolves to the response
 */
proto.components.AppActionsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.AppActions/Create',
      request,
      metadata || {},
      methodDescriptor_AppActions_Create);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.VersionsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.VersionsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListVersionRequest,
 *   !proto.components.ListVersionResponse>}
 */
const methodDescriptor_Versions_List = new grpc.web.MethodDescriptor(
  '/components.Versions/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListVersionRequest,
  proto.components.ListVersionResponse,
  /**
   * @param {!proto.components.ListVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListVersionResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.VersionsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Versions/List',
      request,
      metadata || {},
      methodDescriptor_Versions_List,
      callback);
};


/**
 * @param {!proto.components.ListVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListVersionResponse>}
 *     Promise that resolves to the response
 */
proto.components.VersionsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Versions/List',
      request,
      metadata || {},
      methodDescriptor_Versions_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetVersionRequest,
 *   !proto.components.GetVersionResponse>}
 */
const methodDescriptor_Versions_Get = new grpc.web.MethodDescriptor(
  '/components.Versions/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetVersionRequest,
  proto.components.GetVersionResponse,
  /**
   * @param {!proto.components.GetVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetVersionResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.VersionsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Versions/Get',
      request,
      metadata || {},
      methodDescriptor_Versions_Get,
      callback);
};


/**
 * @param {!proto.components.GetVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetVersionResponse>}
 *     Promise that resolves to the response
 */
proto.components.VersionsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Versions/Get',
      request,
      metadata || {},
      methodDescriptor_Versions_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateVersionResponse>}
 */
const methodDescriptor_Versions_Update = new grpc.web.MethodDescriptor(
  '/components.Versions/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateVersionResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateVersionResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.VersionsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Versions/Update',
      request,
      metadata || {},
      methodDescriptor_Versions_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateVersionResponse>}
 *     Promise that resolves to the response
 */
proto.components.VersionsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Versions/Update',
      request,
      metadata || {},
      methodDescriptor_Versions_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteVersionRequest,
 *   !proto.components.DeleteVersionResponse>}
 */
const methodDescriptor_Versions_Delete = new grpc.web.MethodDescriptor(
  '/components.Versions/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteVersionRequest,
  proto.components.DeleteVersionResponse,
  /**
   * @param {!proto.components.DeleteVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteVersionResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.VersionsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Versions/Delete',
      request,
      metadata || {},
      methodDescriptor_Versions_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteVersionResponse>}
 *     Promise that resolves to the response
 */
proto.components.VersionsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Versions/Delete',
      request,
      metadata || {},
      methodDescriptor_Versions_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateVersionRequest,
 *   !proto.components.CreateVersionResponse>}
 */
const methodDescriptor_Versions_Create = new grpc.web.MethodDescriptor(
  '/components.Versions/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateVersionRequest,
  proto.components.CreateVersionResponse,
  /**
   * @param {!proto.components.CreateVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateVersionResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.VersionsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Versions/Create',
      request,
      metadata || {},
      methodDescriptor_Versions_Create,
      callback);
};


/**
 * @param {!proto.components.CreateVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateVersionResponse>}
 *     Promise that resolves to the response
 */
proto.components.VersionsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Versions/Create',
      request,
      metadata || {},
      methodDescriptor_Versions_Create);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.TranslationsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.TranslationsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.ListTranslationRequest,
 *   !proto.components.ListTranslationResponse>}
 */
const methodDescriptor_Translations_List = new grpc.web.MethodDescriptor(
  '/components.Translations/List',
  grpc.web.MethodType.UNARY,
  proto.components.ListTranslationRequest,
  proto.components.ListTranslationResponse,
  /**
   * @param {!proto.components.ListTranslationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.ListTranslationResponse.deserializeBinary
);


/**
 * @param {!proto.components.ListTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.ListTranslationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.ListTranslationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TranslationsClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Translations/List',
      request,
      metadata || {},
      methodDescriptor_Translations_List,
      callback);
};


/**
 * @param {!proto.components.ListTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.ListTranslationResponse>}
 *     Promise that resolves to the response
 */
proto.components.TranslationsPromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Translations/List',
      request,
      metadata || {},
      methodDescriptor_Translations_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.GetTranslationRequest,
 *   !proto.components.GetTranslationResponse>}
 */
const methodDescriptor_Translations_Get = new grpc.web.MethodDescriptor(
  '/components.Translations/Get',
  grpc.web.MethodType.UNARY,
  proto.components.GetTranslationRequest,
  proto.components.GetTranslationResponse,
  /**
   * @param {!proto.components.GetTranslationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.GetTranslationResponse.deserializeBinary
);


/**
 * @param {!proto.components.GetTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.GetTranslationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.GetTranslationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TranslationsClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Translations/Get',
      request,
      metadata || {},
      methodDescriptor_Translations_Get,
      callback);
};


/**
 * @param {!proto.components.GetTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.GetTranslationResponse>}
 *     Promise that resolves to the response
 */
proto.components.TranslationsPromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Translations/Get',
      request,
      metadata || {},
      methodDescriptor_Translations_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UpdateRequest,
 *   !proto.components.UpdateTranslationResponse>}
 */
const methodDescriptor_Translations_Update = new grpc.web.MethodDescriptor(
  '/components.Translations/Update',
  grpc.web.MethodType.UNARY,
  proto.components.UpdateRequest,
  proto.components.UpdateTranslationResponse,
  /**
   * @param {!proto.components.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UpdateTranslationResponse.deserializeBinary
);


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UpdateTranslationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UpdateTranslationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TranslationsClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Translations/Update',
      request,
      metadata || {},
      methodDescriptor_Translations_Update,
      callback);
};


/**
 * @param {!proto.components.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UpdateTranslationResponse>}
 *     Promise that resolves to the response
 */
proto.components.TranslationsPromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Translations/Update',
      request,
      metadata || {},
      methodDescriptor_Translations_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.DeleteTranslationRequest,
 *   !proto.components.DeleteTranslationResponse>}
 */
const methodDescriptor_Translations_Delete = new grpc.web.MethodDescriptor(
  '/components.Translations/Delete',
  grpc.web.MethodType.UNARY,
  proto.components.DeleteTranslationRequest,
  proto.components.DeleteTranslationResponse,
  /**
   * @param {!proto.components.DeleteTranslationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.DeleteTranslationResponse.deserializeBinary
);


/**
 * @param {!proto.components.DeleteTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.DeleteTranslationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.DeleteTranslationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TranslationsClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Translations/Delete',
      request,
      metadata || {},
      methodDescriptor_Translations_Delete,
      callback);
};


/**
 * @param {!proto.components.DeleteTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.DeleteTranslationResponse>}
 *     Promise that resolves to the response
 */
proto.components.TranslationsPromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Translations/Delete',
      request,
      metadata || {},
      methodDescriptor_Translations_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.CreateTranslationRequest,
 *   !proto.components.CreateTranslationResponse>}
 */
const methodDescriptor_Translations_Create = new grpc.web.MethodDescriptor(
  '/components.Translations/Create',
  grpc.web.MethodType.UNARY,
  proto.components.CreateTranslationRequest,
  proto.components.CreateTranslationResponse,
  /**
   * @param {!proto.components.CreateTranslationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.CreateTranslationResponse.deserializeBinary
);


/**
 * @param {!proto.components.CreateTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.CreateTranslationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.CreateTranslationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.TranslationsClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Translations/Create',
      request,
      metadata || {},
      methodDescriptor_Translations_Create,
      callback);
};


/**
 * @param {!proto.components.CreateTranslationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.CreateTranslationResponse>}
 *     Promise that resolves to the response
 */
proto.components.TranslationsPromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Translations/Create',
      request,
      metadata || {},
      methodDescriptor_Translations_Create);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.StorageClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.components.StoragePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.components.UploadRequest,
 *   !proto.components.UploadResponse>}
 */
const methodDescriptor_Storage_Upload = new grpc.web.MethodDescriptor(
  '/components.Storage/Upload',
  grpc.web.MethodType.UNARY,
  proto.components.UploadRequest,
  proto.components.UploadResponse,
  /**
   * @param {!proto.components.UploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.components.UploadResponse.deserializeBinary
);


/**
 * @param {!proto.components.UploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.components.UploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.components.UploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.components.StorageClient.prototype.upload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/components.Storage/Upload',
      request,
      metadata || {},
      methodDescriptor_Storage_Upload,
      callback);
};


/**
 * @param {!proto.components.UploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.components.UploadResponse>}
 *     Promise that resolves to the response
 */
proto.components.StoragePromiseClient.prototype.upload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/components.Storage/Upload',
      request,
      metadata || {},
      methodDescriptor_Storage_Upload);
};


module.exports = proto.components;

